<template>
  <div class="floating">
    <a
      v-if="this.$route.path === '/' ? false : true"
      @click="redirectToChat()"
      rel="noopener noreferrer"
      class="helper-button"
    >
      <i class="icon-help">
        <span class="path1" />
        <span class="path2" />
        <span class="path3" />
        <span class="path4" />
        <span class="path5" />
      </i>
    </a>
  </div>
</template>

<script>
export default {
  name: 'HelperButton',
  methods: {
    redirectToChat () {
      window.open('http://www.sarah.br/chat')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/stylesheets/base";
@import "~@/assets/stylesheets/buttons";

.floating a {
  color: transparent;

  &:hover {
    color: transparent;
  }
}
</style>
